import { IconButton, SvgIcon } from '@material-ui/core'
import Modal from '@material-ui/core/Modal'
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import React from 'react'
// import { ReactComponent as CloseIcon } from "../assets/images/bb8-close.svg";
import './BB8Modal.scss'
import { BB8ModalSizes, BB8ModalTypes } from './BB8ModalTypes'
const styles = (theme: Theme) =>
  createStyles({
    circle: {
      alignItems: 'center',
      borderRadius: '50%',
      borderStyle: 'solid',
      borderWidth: 3,
      display: 'flex',
      height: 150,
      justifyContent: 'center',
      width: 150
    },
    [BB8ModalTypes.Error]: {
      borderColor: theme.palette.error.main
    },
    iconWrapper: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      margin: '30px auto',
      width: '100%'
    },
    [BB8ModalTypes.Info]: {
      borderColor: theme.palette.secondary.dark
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing.unit * 4,
      position: 'absolute',
      width: theme.spacing.unit * 50
    },
    [BB8ModalTypes.Success]: {
      borderColor: (theme.palette as any).status.success
    },
    svg: {
      height: 86,
      width: 86
    },
    [BB8ModalTypes.Warning]: {
      borderColor: (theme.palette as any).status.warning
    }
  })

const IconWrapper = ({
  children,
  classes,
  type
}: {
  children: any
  classes: any
  type: BB8ModalTypes
}) => (
  <div className={classes.iconWrapper}>
    <div className={classNames(classes.circle, classes[type])}>
      <SvgIcon viewBox="0 0 16 16" className={classes.svg}>
        {children}
      </SvgIcon>
    </div>
  </div>
)

const modalIcons: { [type: string]: React.SFC<any> } = {
  [BB8ModalTypes.Error]: ({ classes }: { classes: any }) => (
    <IconWrapper classes={classes} type={BB8ModalTypes.Error}>
      <path
        d="M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z"
        stroke="#D30E8B"
        strokeWidth="1"
        fillRule="nonzero"
      />
    </IconWrapper>
  ),
  [BB8ModalTypes.Info]: ({ classes }: { classes: any }) => (
    <IconWrapper classes={classes} type={BB8ModalTypes.Info}>
      <path
        d="M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z"
        stroke="#D30E8B"
        strokeWidth="1"
        fillRule="nonzero"
      />
    </IconWrapper>
  ),
  [BB8ModalTypes.Success]: ({ classes }: { classes: any }) => (
    <IconWrapper classes={classes} type={BB8ModalTypes.Success}>
      <path style={{ fill: 'none' }} id="path3713" d="M 0,-8 H 24 V 16 H 0 Z" />
      <path
        style={{ fill: '#008000', strokeWidth: 0.89599383 }}
        id="path3715"
        d="M 5.0175655,11.762402 1.2543914,7.9992295 0,9.2536208 5.0175655,14.271185 15.769493,3.519261 14.515101,2.2648696 Z"
      />
    </IconWrapper>
  ),
  [BB8ModalTypes.Warning]: ({ classes }: { classes: any }) => (
    <IconWrapper classes={classes} type={BB8ModalTypes.Warning}>
      <path
        d="M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z"
        stroke="#D30E8B"
        strokeWidth="1"
        fillRule="nonzero"
      />
    </IconWrapper>
  )
}

export interface IBB8ModalProps {
  open: boolean
  onClose?: any
  type?: BB8ModalTypes
  size?: BB8ModalSizes
}

export interface IStyledBB8ModalProps extends IBB8ModalProps, WithStyles<typeof styles> {}

const BB8SimpleModal: React.SFC<IStyledBB8ModalProps> = props => {
  const { children, classes, open, onClose, type, size } = props
  const Icon = modalIcons[type || 'none']
  return (
    <Modal
      aria-labelledby="bb8-modal-title"
      aria-describedby="bb8-modal-description"
      open={open}
      onClose={onClose}
    >
      <div
        className={classNames(classes.paper, 'modal-content', {
          default: !size || size === BB8ModalSizes.Default,
          medium: size && size === BB8ModalSizes.Medium,
          small: size && size === BB8ModalSizes.Small
        })}
      >
        <IconButton onClick={onClose} className="btn-close-modal">
          <svg
            width="17px"
            height="16px"
            viewBox="0 0 17 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <path
                d="M5.95199981,7.99999974 L0.639999984,2.68799992 C0.383999993,2.43199993 0.128000001,1.91999994 0.128000001,1.53599995 C0.128000001,0.76799998 0.76799998,0.128000001 1.53599995,0.128000001 C1.91999994,0.128000001 2.30399993,0.383999993 2.68799992,0.639999984 L7.99999974,5.95199981 L13.3119996,0.639999984 C13.5679996,0.383999993 13.9519995,0.128000001 14.4639995,0.128000001 C15.2319995,0.128000001 15.8719995,0.76799998 15.8719995,1.53599995 C15.8719995,1.91999994 15.6159995,2.30399993 15.3599995,2.55999992 L9.98399968,7.93599974 L15.4879995,13.4399996 C15.7439995,13.6959996 15.8719995,14.0799995 15.8719995,14.4639995 C15.8719995,15.2319995 15.2319995,15.8719995 14.4639995,15.8719995 C14.0799995,15.8719995 13.6959996,15.7439995 13.4399996,15.4879995 L7.93599974,9.98399968 L2.55999992,15.3599995 C2.30399993,15.7439995 1.91999994,15.8719995 1.53599995,15.8719995 C0.76799998,15.8719995 0.128000001,15.2319995 0.128000001,14.4639995 C0.128000001,14.0799995 0.255999997,13.6959996 0.511999988,13.4399996 L5.95199981,7.99999974 Z"
                id="path-1"
              />
            </defs>
            <g id="Visuals" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Billing---Issuer-details" transform="translate(-1392.000000, -275.000000)">
                <g
                  id="UI-/-cards-/-details-/-Customer-ID-thin-Copy"
                  transform="translate(0.000000, 242.000000)"
                >
                  <g id="Customer-ID-card">
                    <g id="Group" transform="translate(1281.333333, 29.000000)">
                      <g id="Icon/Close" transform="translate(111.000000, 4.000000)">
                        <g id="Icon-/-lineart-/--functional-secondary-close">
                          <mask id="mask-2" fill="white">
                            <use href="#path-1" />
                          </mask>
                          <use
                            id="Combined-Shape"
                            fill="#717272"
                            fill-rule="nonzero"
                            href="#path-1"
                          />
                          <g id="colors/global/Dark-grey" mask="url(#mask-2)" fill="#7C7E80">
                            <g transform="translate(-9.333333, -9.333333)" id="color">
                              <rect x="0" y="0" width="34.6666679" height="34.6666679" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </IconButton>
        {Icon ? <Icon classes={classes} /> : undefined}
        {React.Children.map(children, child => child)}
      </div>
    </Modal>
  )
}

const BB8Modal = withStyles(styles)(BB8SimpleModal)

export default BB8Modal
